import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { useSelector } from 'react-redux';
import { RootState } from '../types/graph';
import { useSessionInfo } from '../hooks/useSessionInfo';
import * as Sentry from '@sentry/react';

export default function PostHogPageView() {
  const sessionId = useSelector((state: RootState) => state.sessionId);
  const practiceId = useSelector(
    (state: RootState) => state.consultation.practice?.id,
  );
  const sessionInfo = useSessionInfo();
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      posthog.capture('$pageview');
      console.log(`Current location : ${location.pathname}`);
    }
  }, [location, posthog, sessionInfo.variant]);

  useEffect(() => {
    if (sessionId) {
      Sentry.setUser({ id: `session_${sessionId}` });
    }
  }, [sessionId]);

  useEffect(() => {
    Sentry.setTag('practiceId', practiceId ? String(practiceId) : undefined);
  }, [practiceId]);

  useEffect(() => {
    if (posthog && sessionId) {
      posthog.identify(`session_${sessionId}`);
    }
  }, [sessionId, posthog]);

  useEffect(() => {
    if (posthog && sessionId) {
      posthog.setPersonProperties(sessionInfo);
    }
  }, [sessionId, posthog, sessionInfo]);

  // Sync person properties used for experiment targeting so PostHog re-evaluates
  // feature flag assignments when these values become available.
  useEffect(() => {
    if (posthog && sessionInfo.practiceOnboardingDisplayMode !== undefined) {
      posthog.setPersonPropertiesForFlags({
        practiceOnboardingDisplayMode:
          sessionInfo.practiceOnboardingDisplayMode,
      });
    }
  }, [posthog, sessionInfo.practiceOnboardingDisplayMode]);

  useEffect(() => {
    if (posthog && sessionInfo.patientSegment !== undefined) {
      posthog.setPersonPropertiesForFlags({
        patientSegment: sessionInfo.patientSegment,
      });
    }
  }, [posthog, sessionInfo.patientSegment]);

  return null;
}
